import { useState, useEffect, Suspense } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, json, Form } from 'react-router-dom'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/PassageList.module.scss'
import LoadingSpinner from './components/LoadingSpinner'
import { getIdeaList, uploadRequestDocIdea, deleteIdea } from '../util/p_api'
import '../../node_modules/leaflet-draw/dist/leaflet.draw.css'
import { useAuth } from '../contexts/AuthContext'
import Download from './download'
import { toast } from 'react-hot-toast'

export default function Idea({title}) {
  const pageName = title
  Title(pageName)
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState()
  const [user, setUser] = useState(null)
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const statusInterpreter = ['ثبت شده', 'دیده شده', 'تایید شده', 'رد شده', 'ارجاع برای تماس']

  const handleUpdate = async (e, id, field) => {
    const t = toast.loading(`در حال ارسال فایل ...`)
    try {
      const res = await uploadRequestDocIdea(e.target.files[0], id, field)
      console.log(res)
      if (res.result) {
        alert('درخواست با موفقیت ارسال گردید')
        window.location.reload()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const determineStatus = (status) => {
    let result

    switch (status) {
      case '0':
      case 0:
        result = <span className="badge badge-light">{statusInterpreter[0]}</span>
        break
      case '1':
      case 1:
        result = (
          <span className="badge" style={{ background: 'linear-gradient(100deg, #eee 0.72%, #FD0017 98.42%)', color: '#fff' }}>
            {statusInterpreter[1]}
          </span>
        )
        break
      case '2':
      case 2:
        result = <span className="badge badge-primary">{statusInterpreter[2]}</span>
        break
      case '3':
      case 3:
        result = <span className="badge badge-warning animated animate__animated animate__heartBeat animate__delay-2s animate__infinite ">{statusInterpreter[3]}</span>
        break
      case '4':
      case 4:
        result = (
          <span className="badge badge-success" style={{ transform: 'rotate(-14deg) scale(1.4)' }}>
            {statusInterpreter[4]}
          </span>
        )
        break
      case '5':
      case 5:
        result = (
          <span className="badge badge-danger" style={{ transform: 'rotate(-14deg) scale(1.4)' }}>
            {statusInterpreter[5]}
          </span>
        )
        break
      case '6':
      case 6:
        result = <span className="badge badge-dark">{statusInterpreter[6]}</span>
        break
      default:
        result = <span className="badge badge-primary">تعریف نشده</span>
        break
    }

    return result
  }

  const handleDelete = (id) => {
    if (window.confirm('از حذف این درخواست مطمئن هستید؟')) {
      deleteIdea(id).then((res) => {
        toast('درخواست شما با موفقیت پاک شد')
        window.location.reload()
        getIdeaList(loaderData.user?.mobile).then((res) => {
          console.log(res)
          setData(res)
        })
      })
    }
  }

  useEffect(() => {
    document.querySelector('header span').innerText = title

    getIdeaList(loaderData.user?.mobile).then((res) => {
      console.log(res)
      setData(res)
    })
  }, [])

  return (
    <section className={styles.section}>
      <div className={`__frame`} data-width={`xlarge`}>
        <div className="alert alert--info">تا زمانی که وضعیت درخواست "ثبت شده" می باشد، امکان ویرایش درخواست ارسالی می باشد.</div>
        <div className="alert alert--warning">برای ویرایش فایل ارسال شده لطفا از قسمت فایل پیوست شده همین صفحه اقدام نمائید.</div>
        <div className="table-responsive">
          <table>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شناسه</th>
                <th>دسته بندی</th>
                <th>عنوان</th>
                <th>توضیحات</th>
                <th>فایل 1</th>
                <th>فایل 2</th>
                <th>فایل 3</th>
                <th>فایل 4</th>
                <th>فایل 5</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data
                  .filter((item) => item.page === `idea`)
                  .map((item, i) => {
                    return (
                      <tr key={i} style={{ backgroundColor: i === 0 ? 'var(--blue-050)' : null }}>
                        <td>{++i}</td>
                        <td>{item.id}</td>
                        <td>{item.ideaCategoryName + ' > ' + item.ideaCategoryName2}</td>
                        <td>{item.title}</td>
                        <td>{item.description}</td>

                        <td>
                          {item.file1 !== null ? (
                            <a target="_blank" className={`${styles.successAlert}`} href={`${process.env.REACT_APP_UPLOAD}images/${item.file1}`} download={true}>
                              فایل شما با موفقیت ارسال گردیده است
                              <br />
                              دانلود فایل ارسالی
                            </a>
                          ) : (
                            <>
                              <span className={styles.warningAlert}>هنوز فایلی ارسال نشده است.</span>
                            </>
                          )}
                          {item.status === '0' && (
                            <details>
                              <summary>ویرایش فایل</summary>
                              <div className={styles.formGroup}>
                                <input type={'file'} name={'mainAttachment'} onChange={(e) => handleUpdate(e, item.id, 'file1')} />
                              </div>
                            </details>
                          )}
                        </td>

                        <td>
                          {item.file2 !== null ? (
                            <a target="_blank" className={`${styles.successAlert}`} href={`${process.env.REACT_APP_UPLOAD}images/${item.file2}`} download={true}>
                              فایل شما با موفقیت ارسال گردیده است
                              <br />
                              دانلود فایل ارسالی
                            </a>
                          ) : (
                            <>
                              <span className={styles.warningAlert}>هنوز فایلی ارسال نشده است.</span>
                            </>
                          )}
                          {item.status === '0' && (
                            <details>
                              <summary>ویرایش فایل</summary>
                              <div className={styles.formGroup}>
                                <input type={'file'} name={'mainAttachment'} onChange={(e) => handleUpdate(e, item.id, 'file2')} />
                              </div>
                            </details>
                          )}
                        </td>

                        <td>
                          {item.file3 !== null ? (
                            <a target="_blank" className={`${styles.successAlert}`} href={`${process.env.REACT_APP_UPLOAD}images/${item.file3}`} download={true}>
                              فایل شما با موفقیت ارسال گردیده است
                              <br />
                              دانلود فایل ارسالی
                            </a>
                          ) : (
                            <>
                              <span className={styles.warningAlert}>هنوز فایلی ارسال نشده است.</span>
                            </>
                          )}
                          {item.status === '0' && (
                            <details>
                              <summary>ویرایش فایل</summary>
                              <div className={styles.formGroup}>
                                <input type={'file'} name={'mainAttachment'} onChange={(e) => handleUpdate(e, item.id, 'file3')} />
                              </div>
                            </details>
                          )}
                        </td>

                        <td>
                          {item.file4 !== null ? (
                            <a target="_blank" className={`${styles.successAlert}`} href={`${process.env.REACT_APP_UPLOAD}images/${item.file4}`} download={true}>
                              فایل شما با موفقیت ارسال گردیده است
                              <br />
                              دانلود فایل ارسالی
                            </a>
                          ) : (
                            <>
                              <span className={styles.warningAlert}>هنوز فایلی ارسال نشده است.</span>
                            </>
                          )}
                          {item.status === '0' && (
                            <details>
                              <summary>ویرایش فایل</summary>
                              <div className={styles.formGroup}>
                                <input type={'file'} name={'mainAttachment'} onChange={(e) => handleUpdate(e, item.id, 'file4')} />
                              </div>
                            </details>
                          )}
                        </td>

                        <td>
                          {item.file5 !== null ? (
                            <a target="_blank" className={`${styles.successAlert}`} href={`${process.env.REACT_APP_UPLOAD}images/${item.file5}`} download={true}>
                              فایل شما با موفقیت ارسال گردیده است
                              <br />
                              دانلود فایل ارسالی
                            </a>
                          ) : (
                            <>
                              <span className={styles.warningAlert}>هنوز فایلی ارسال نشده است.</span>
                            </>
                          )}
                          {item.status === '0' && (
                            <details>
                              <summary>ویرایش فایل</summary>
                              <div className={styles.formGroup}>
                                <input type={'file'} name={'mainAttachment'} onChange={(e) => handleUpdate(e, item.id, 'file5')} />
                              </div>
                            </details>
                          )}
                        </td>

                        <td>{determineStatus(item.status)}</td>
                        <td>
                          {item.status === '0' ? (
                            <>
                              <button onClick={() => navigate('/idea/edit/' + item.id)}>ویرایش</button>|<button onClick={() => handleDelete(item.id)}>حذف</button>
                            </>
                          ) : (
                            <>درحال بررسی.</>
                          )}
                        </td>
                      </tr>
                    )
                  })}
            </tbody>
          </table>
        </div>

        <div className="text-center" style={{ textAlign: 'center', marginTop: '1rem' }}>
          <button className="button" onClick={() => navigate(`../`)}>
            بازگشت
          </button>
        </div>
      </div>
    </section>
  )
}
